/** Base path when hosted under a subfolder (e.g. /partner-login on tripiigo.com) */
const fromEnv = (process.env.REACT_APP_BASE_PATH || '').trim().replace(/\/$/, '');
const fromPublic = (process.env.PUBLIC_URL || '').trim().replace(/\/$/, '');

export const APP_BASE_PATH = fromEnv || fromPublic;

/** Prefix an app route — use for full-page redirects outside React Router */
export function withBasePath(path: string): string {
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${APP_BASE_PATH}${p}`;
}
